import React from 'react';
import { ArrowForward } from '@yme/assets/icons';
import { Button, GHOST_VARIANT, SIZE_44, TRAILING_ICON } from '@yme/atoms/button';
import { useWindowSize } from '@yme/common/hooks';
import { ButtonLinkWrapper } from '@yme/molecules/buttons';
import { colorCoreBlack300, colorCoreBlack900Base } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { HeadingLevel2, HeadingLevel4 } from '@yme/tokens/typography';
import { ContentBlockStyled, DescriptionStyled } from './styled';
export function TabletMobileContent({ button, description, subtitle, title, isRightToLeft, onClick, }) {
    const { isMobileView } = useWindowSize();
    return (React.createElement(ContentBlockStyled, { flexDirection: "column" },
        subtitle && (React.createElement(FlexWrapper, null,
            React.createElement(HeadingLevel4, { color: colorCoreBlack300 }, subtitle))),
        React.createElement(FlexWrapper, null,
            React.createElement(HeadingLevel2, { color: colorCoreBlack900Base }, title)),
        description && (React.createElement(FlexWrapper, { pt: "8px" },
            React.createElement(DescriptionStyled, { color: colorCoreBlack300 }, description))),
        React.createElement(FlexWrapper, { ptTablet: "16px", ptMobile: "24px" },
            React.createElement(ButtonLinkWrapper, { buttonLink: button.link, onClick: onClick },
                React.createElement(Button, { isRightToLeft: isRightToLeft, buttonVariant: GHOST_VARIANT, hasIconButton: TRAILING_ICON, iconComponent: ArrowForward, size: SIZE_44, label: button.text, width: isMobileView ? '100%' : 'auto' })))));
}
